import { useSuspenseGqlQuery } from "@/lib/GraphQLCodegen/fetcher";
import { vehicleRecordQuery } from "@/app/Vehicles/GraphQL/vehicleRecordQuery";
import { useSearch } from "@tanstack/react-router";

export function useVehicleDrawer() {
  const search = useSearch({
    from: "/$tenant/$orgId/supplier/{-$supplierId}",
  });

  if (!search.vehicleId) {
    throw new Error("Vehicle id is not present in the search params");
  }

  const { data } = useSuspenseGqlQuery(vehicleRecordQuery, {
    id: search.vehicleId,
  });

  return data.vehicle;
}
